import React from 'react'
import waIcon from '../assets/whatsapp.png'

const FloatingButtons = () => {
  const wrapperStyle = {
    position: 'fixed',
    right: '20px',
    bottom: '20px',
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  }

  const baseButton = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    padding: '12px 16px',
    borderRadius: '999px',
    color: '#fff',
    textDecoration: 'none',
    boxShadow: '0 6px 18px rgba(0,0,0,0.15)',
    fontWeight: 600,
    fontSize: '14px'
  }

  const waStyle = {
    ...baseButton,
    backgroundColor: '#ffffff',
    color: '#111',
    boxShadow: '0 6px 18px rgba(0,0,0,0.08)',
    border: '1px solid rgba(0,0,0,0.06)'
  }

  const ltStyle = {
    ...baseButton,
    backgroundColor: '#111'
  }

  const iconStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    background: '#25D366',
    fontSize: '16px'
  }

  return (
    <div style={wrapperStyle} aria-hidden={false}>
      <a
        href="https://wa.link/wwanfq"
        target="_blank"
        rel="noreferrer"
        title="WhatsApp - Text us"
        style={waStyle}
      >
        <span>WhatsApp - Text us</span>
        <span style={iconStyle} aria-hidden>
          <img
            src={waIcon}
            alt="WhatsApp"
            style={{ width: '18px', height: '18px' }}
            onError={(e) => {
              e.target.style.display = 'none'
              const fallback = e.target.nextElementSibling
              if (fallback) fallback.style.display = 'inline'
            }}
          />
          <span style={{ display: 'none' }}>🟢</span>
        </span>
      </a>

      <a
        href="https://linktr.ee/smgarctic"
        target="_blank"
        rel="noreferrer"
        title="Linktree - Checkout our linktree"
        style={ltStyle}
      >
        <span>Checkout our linktree</span>
        <span style={iconStyle} aria-hidden>
          🔗
        </span>
      </a>
    </div>
  )
}

export default FloatingButtons
